<template>
	<div class="container-theme-preview">
		<div class="theme-preview" v-if="!!selectedTheme" :class="{light: selectedTheme && selectedTheme.light}">
			<div class="theme-preview-item theme-preview-left-top" :style="'background-color: #'+selectedTheme.bg_1"></div>
			<div class="theme-preview-item theme-preview-right-top" :style="'background-color: #'+selectedTheme.txt_1"></div>
			<div class="theme-preview-item theme-preview-left-bottom" :style="'background-color: #'+selectedTheme.txt_2"></div>
			<div class="theme-preview-item theme-preview-right-bottom" :style="'background-color: #'+selectedTheme.bg_2"></div>
		</div>
		<AppButton :text="selectedTheme ? selectedTheme.name : 'open'" class="text-uppercase" outline @click="toggleBottomSheet" />
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="chooserColorBottomSheet" @toggling-popup="togglingPopup">
			<div class="theme-container" v-if="chooserColorBottomSheet">
				<ModalHeader :title="getString('choose_color_theme')" :button-text="getString('save')" @click-button="saveClicked" :button-loading="loadingTheme" />
				<div class="wrapper-content-bottom-sheet">
					<p class="title-category-theme">{{ getString('light_themes') }}</p>
					<div class="wrapper-items-color-chooser">
						<div class="input-color-theme" v-for="(theme, index) in lightThemes" :key="index" :class="{ active: theme.menu_theme_id === userStore.currBusiness.menu_theme_id }" @click="selectTheme(theme)">
							<p> {{ theme.name }}</p>
							<div class="container-slide">
								<div class="preview-color-slide" :style="'background-color: #'+theme.bg_1">
									<p :style="'color: #'+theme.txt_1">{{ getString('label_primary_color_background') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.bg_2">
									<p :style="'color: #'+theme.txt_2">{{ getString('label_secondary_color_background') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.txt_1">
									<p :style="'color: #'+theme.bg_1">{{ getString('label_primary_color_text') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.txt_2">
									<p :style="'color: #'+theme.bg_2">{{ getString('label_secondary_color_text') }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="wrapper-content-bottom-sheet">
					<p class="title-category-theme title-category-theme-dark">{{ getString('dark_themes') }}</p>
					<div class="wrapper-items-color-chooser">
						<div class="input-color-theme" v-for="(theme, index) in darkThemes" :key="index" :class="{ active: theme.menu_theme_id === userStore.currBusiness.menu_theme_id }" @click="selectTheme(theme)">
							<p> {{ theme.name }}</p>
							<div class="container-slide">
								<div class="preview-color-slide" :style="'background-color: #'+theme.bg_1">
									<p :style="'color: #'+theme.txt_1">{{ getString('label_primary_color_background') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.bg_2">
									<p :style="'color: #'+theme.txt_2">{{ getString('label_secondary_color_background') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.txt_1">
									<p :style="'color: #'+theme.bg_1">{{ getString('label_primary_color_text') }}</p>
								</div>
								<div class="preview-color-slide" :style="'background-color: #'+theme.txt_2">
									<p :style="'color: #'+theme.bg_2">{{ getString('label_secondary_color_text') }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>

import {defineComponent} from "vue";
import {useUnchangingStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppButton from "@/shared/components/AppButton.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";

export default defineComponent({
	setup() {
		let userStore = useUserStore();
		let languageStore = useLanguageStore();
		const unchangingStore = useUnchangingStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, unchangingStore, userStore, showNotification: notificationStore.showNotification}
	},
	mixins: [WindowWidth],
	name: "ColorThemeChooser",
	components: {ModalHeader, AppButton, AppSelect, AppBottomSheet},
	data() {
		return {
			chooserColorBottomSheet: false,
			loadingTheme: false,
		}
	},
	methods: {
		togglingPopup(open) {
			this.chooserColorBottomSheet = !!open;
		},
		toggleBottomSheet() {
			this.chooserColorBottomSheet = !this.chooserColorBottomSheet;
		},
		selectTheme(theme) {
			this.userStore.currBusiness.menu_theme_id = theme.menu_theme_id;
		},
		saveClicked() {

			this.loadingTheme = true;
			this.userStore.updateBusiness({
				menu_theme_id: this.userStore.currBusiness.menu_theme_id,
			}, (success) => {
				this.loadingTheme = false;
				if (success) {
					this.showNotification("generic-success");
					this.toggleBottomSheet();
					this.$emit('themeSelected', this.userStore.currBusiness.menu_theme_id);
				} else {
					this.showNotification("generic-fail");
				}
			});

		}
	},
	computed: {
		selectedThemeIndex() {
			if(this.userStore.currBusiness && this.unchangingStore.themes) {
				let foundIndex = this.unchangingStore.themes.findIndex((theme) => theme.menu_theme_id === this.userStore.currBusiness.menu_theme_id);
				return foundIndex !== -1 ? foundIndex : 0;
			} else {
				return 0;
			}
		},
		selectedTheme() {
			return this.unchangingStore.themes ? this.unchangingStore.themes[this.selectedThemeIndex] : {};
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		lightThemes() {
			return this.unchangingStore.themes.filter(theme => theme.light);
		},
		darkThemes() {
			return this.unchangingStore.themes.filter(theme => !theme.light);
		},
	},
})
</script>

<style scoped lang="scss">
.container-theme-preview {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-left: 20px;

	@media (max-width: 400px) {
		margin-left: auto;
	}

	.theme-preview {
		width: 40px;
		height: 40px;
		margin-right: 8px;
		border-radius: 13px;
		border: 1px solid #cccccc;
		transition: border 0.2s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		flex: 1;
		flex-wrap: wrap;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: calc(50% - 1px);
			width: 1px;
			height: 100%;
			background-color: #cccccc;
			transition: background-color 0.2s ease;
		}

		&::after {
			content: "";
			position: absolute;
			top: calc(50% - 1px);
			left: 0;
			width: 100%;
			height: 1px;
			background-color: #cccccc;
			transition: background-color 0.2s ease;
		}

		&.light {
			border: 1px solid #262626;

			&::before {
				background-color: #262626;
			}

			&::after {
				background-color: #262626;
			}
		}

		.theme-preview-item {
			width: 50%;
			height: 50%;
			transition: background-color 0.2s ease;

			&.theme-preview-left-top {
				border-top-left-radius: 12px;
			}

			&.theme-preview-right-top {
				border-top-right-radius: 12px;
			}

			&.theme-preview-left-bottom {
				border-bottom-left-radius: 12px;
			}

			&.theme-preview-right-bottom {
				border-bottom-right-radius: 12px;
			}

		}
	}

	.select-wrapper {
		flex: 1;
	}
	.text-uppercase {
		text-transform: capitalize;
	}
}
.wrapper-content-bottom-sheet {
	margin-bottom: 30px;
	.title-category-theme {
		font-size: 22px;
		line-height: 26px;
		font-weight: 600;
		margin-bottom: 10px;
		text-transform: capitalize;
		padding: 10px 20px;
		border: 1px solid $alpha_3;
		border-radius: 13px;
		&-dark {
			background-color: #011020;
			border: 1px solid #011020;
			color: #ffffff;
			border-radius: 13px;
		}
	}
	.wrapper-items-color-chooser {
		display: flex;
		flex-wrap: wrap;
		gap: 10px 40px;
		@media (max-width: 1080px) {
			gap: 10px;
		}
		.input-color-theme {
			display: flex;
			flex-direction: column;
			flex: 0 0 50%;
			max-width: calc(50% - 20px);
			padding: 10px;
			border-radius: 0;
			cursor: pointer;
			border: 1px solid transparent;
			@media (max-width: 1080px) {
				max-width: calc(50% - 5px);
			}
			@media (max-width: 768px) {
				flex: 0 0 100%;
				max-width: 100%;
			}
			p {
				font-size: 22px;
				line-height: 26px;
				font-weight: 600;
				margin-bottom: 5px;
				margin-left: 10px;
				text-transform: capitalize;
			}
			.container-slide {
				height: 90px;
				width: 100%;
				display: flex;
				overflow: hidden;
				border-radius: 13px;
				box-shadow: 0 1px 2px var(--color-alpha-4);
				.preview-color-slide {
					flex: 0 0 25%;
					max-width: 25%;
					height: 100%;
					padding: 10px;
					display: flex;
					align-items: flex-end;
					@media (max-width: 365px) {
						padding: 8px;
					}
					p {
						font-size: 12px;
						line-height: 13px;
						font-weight: 300;
						margin: 0;
						@media (max-width: 1080px) {
							font-size: 10px;
							line-height: 11px;
						}
						@media (max-width: 365px) {
							font-size: 8px;
							line-height: 9px;
						}
					}
				}
			}
			&:hover {
				border: 1px solid transparent;
				background-color: $alpha_1;
				border-radius: 13px;
			}
			&.active {
				border: 1px solid $primary;
				background-color: $alpha_1;
				border-radius: 13px;
			}
		}
	}
}
</style>